<i [ngClass]="{ 'text-danger': !value, 'text-success': value }" class="fa fa-{{value ? 'check' : 'ban'}}"></i>